const LOADING_ATTR = 'data-atc-loading';
const RESET_TIMEOUT_MS = 10000;

/**
 * @param {HTMLFormElement} form
 * @param {boolean} loading
 */
function setProductCardAtcLoading(form, loading) {
  const button = form.querySelector('[data-product-card-atc-button]');
  const label = form.querySelector('[data-product-card-atc-label]');

  if (!button || !label) return;

  const timeoutId = Number(form.dataset.atcTimeoutId);
  if (timeoutId) {
    clearTimeout(timeoutId);
    delete form.dataset.atcTimeoutId;
  }

  if (loading) {
    form.setAttribute(LOADING_ATTR, 'true');
    button.disabled = true;
    label.textContent = button.dataset.loadingText || 'Agregando al carrito';

    form.dataset.atcTimeoutId = String(
      window.setTimeout(() => {
        setProductCardAtcLoading(form, false);
      }, RESET_TIMEOUT_MS)
    );

    return;
  }

  form.removeAttribute(LOADING_ATTR);
  button.disabled = false;
  label.textContent = button.dataset.defaultText || 'Agregar al carrito';
}

/**
 * @param {Event} event
 */
function handleProductCardSubmit(event) {
  const form = event.target;

  if (!(form instanceof HTMLFormElement)) return;
  if (!form.hasAttribute('data-product-card-atc-form')) return;

  const button = form.querySelector('[data-product-card-atc-button]');
  if (!button || button.disabled) return;

  setProductCardAtcLoading(form, true);
}

/**
 * @param {CustomEvent} event
 */
function handleCartUpdate(event) {
  const { data } = event.detail || {};

  if (data?.source !== 'product-form-component') return;

  const productId = data?.productId;
  if (!productId) return;

  document
    .querySelectorAll(`product-form-component[data-product-card-form][data-product-id="${productId}"]`)
    .forEach((component) => {
      const form = component.querySelector('[data-product-card-atc-form][data-atc-loading]');
      if (form instanceof HTMLFormElement) {
        setProductCardAtcLoading(form, false);
      }
    });
}

/**
 * @param {CustomEvent} event
 */
function handleCartError(event) {
  const sourceId = event.detail?.sourceId;
  if (!sourceId) return;

  const form = document.getElementById(sourceId);
  if (form instanceof HTMLFormElement && form.hasAttribute('data-product-card-atc-form')) {
    setProductCardAtcLoading(form, false);
  }
}

document.addEventListener('submit', handleProductCardSubmit, true);
document.addEventListener('cart:update', handleCartUpdate);
document.addEventListener('cart:error', handleCartError);
